import React from 'react';

import WarningICon from '../UIElements/Icons/warning.svg';
import { View, Loc } from "./All";

const WARNING_BOX_COLOR = '#EA891E'

const AlertCard = ({title, description}) => (
	<View style={{
		flex: -1,
		boxSizing: 'border-box',
		flexWrap: 'nowrap',
		placeContent: 'space-between',
		alignItems: 'stretch',
		textAlign: 'left'
	}}>
		<View style={{
			justifyContent: 'space-between',
			alignItems: 'flex-start',
			boxShadow: 'rgba(0, 0, 0, 0.06) 0px 0px 0px 1px, rgba(0, 0, 0, 0.03) 0px 3px 6px 0px, rgba(0, 0, 0, 0.1) 0px 1px 2px 0px',
			borderTop: `3px solid ` + WARNING_BOX_COLOR,
			borderRadius: '6px',
			padding: '12px 18px',
			lineHeight: 'normal',
			background: 'rgb(255, 251, 245)',
			borderRightColor: WARNING_BOX_COLOR,
			borderBottomColor: WARNING_BOX_COLOR,
			borderLeftColor: WARNING_BOX_COLOR,
			flex: -1
		}}>
			<View style={{position: 'relative', paddingLeft: '30px', display: 'block', flex: -1}}>
				<View style={{position: 'absolute', left: '0px', top: '2px'}}>
					<img src={WarningICon} alt="warning"/>
				</View>
				<p style={{
					margin: 0,
					color: '#020203',
					fontSize: '14px',
					marginTop: 0,
					marginRight: 0,
					marginBottom: '6px',
					marginLeft: 0,
					fontFamily: 'Lato',
					fontWeight: 700
				}}><Loc locKey={title}></Loc></p>
				<p style={{fontSize: '14px', color: '#5C626A', fontFamily: 'Lato', margin: 0}}><Loc locKey={description}></Loc>
				</p>
			</View>
		</View>
	</View>
)
export {AlertCard}
